import { FC } from "react";
import { Space, Typography } from "antd";
import { FormattedMessage } from "react-intl";
import Header from "components/layout/Header";

import OrganizationForm from "../OrganizationForm";

import { useOrganizationEdit } from "./hooks";

const OrganizationEdit: FC = () => {
  const { initialValues, loading, handleSubmit, onValuesChange, form } =
    useOrganizationEdit();

  return (
    <>
      <Header>
        <Typography.Title>
          <FormattedMessage defaultMessage="Edit organization" />
        </Typography.Title>
      </Header>
      <Space />
      <OrganizationForm
        loading={loading}
        form={form}
        onValuesChange={onValuesChange}
        submitHandler={handleSubmit}
        initialValues={initialValues}
      />
    </>
  );
};

export default OrganizationEdit;
